<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="organisateur_orgouperso" v-model="sasAccreditation.organisateurIndividuOuOrganisme" :live="liveSasAccreditation(24621)" />
    <SearchOrganisation
      v-if="
        !organisation &&
        !sasAccreditation.organisationNonTrouvee &&
        getCatalogueCodeById($constants.DESCID.ACCREDITATION.ORGANISATION_OU_INDIVIDU, sasAccreditation.organisateurIndividuOuOrganisme) ===
          $constants.CODE.ORGANISATION_OU_INDIVIDU.ORGANISATION
      "
      :rules="[(v) => !!organisation || 'Veuillez sélectionner une organisation']"
      @organisation-selected="organisationSelected"
      organisationLabeling="organisation"
      organisationLabelingFeminin
      isAccreditation
      :checkStartDate="false"
    />
    <div v-if="organisation">
      <ressource code="etablissement" class="caption" />
      <v-card class="px-6 pt-3 mb-3" outlined max-width="450">
        <div class="text-right">
          <v-btn icon @click="clearOrganisation"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <h3>{{ organisation.organisation }}</h3>
        <p>{{ organisation.codePostal }}</p>
      </v-card>
    </div>
    <CaseACocherLive
      code="organisation_non_trouvee"
      :opq-if="
        !organisation &&
        getCatalogueCodeById($constants.DESCID.ACCREDITATION.ORGANISATION_OU_INDIVIDU, sasAccreditation.organisateurIndividuOuOrganisme) ===
          $constants.CODE.ORGANISATION_OU_INDIVIDU.ORGANISATION
      "
      v-model="sasAccreditation.organisationNonTrouvee"
      :live="liveSasAccreditation(24622)"
    />
    <TextFieldLive
      code="organisation_nom"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.nomDeLOrganisme"
      :live="liveSasAccreditation(24623)"
    />
    <TextFieldLive
      code="organisation_adresse_ligne_1"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.adresseLigne1"
      :live="liveSasAccreditation(24624)"
      id="adresse-field"
      ref="adresse"
    />
    <TextFieldLive
      code="organisation_adresse_ligne_2"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.adresseLigne2"
      :live="liveSasAccreditation(24625)"
      ref="completementDAdresse"
    />
    <TextFieldLive
      code="organisation_ville"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.ville"
      :live="liveSasAccreditation(24627)"
      ref="ville"
    />
    <TextFieldLive
      code="organisation_codepostal"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.codePostal"
      :live="liveSasAccreditation(24629)"
      ref="codePostal"
    />

    <CatalogueLive
      code="organisation_pays"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.pays"
      :live="liveSasAccreditation(24638)"
      ref="pays"
    />
    <CatalogueLive
      code="organisation_province"
      :opq-if="paysEstCanada(sasAccreditation.pays) && sasAccreditation.organisationNonTrouvee"
      :parent="sasAccreditation.pays"
      v-model="sasAccreditation.province"
      :live="liveSasAccreditation(24630)"
      ref="province"
    />
    <TextFieldLive
      code="organisation_telephone"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.telephoneDeLOrganisme"
      :live="liveSasAccreditation(24639)"
    />
    <CatalogueLive
      code="organisation_faculte"
      :opq-if="sasAccreditation.organisationNonTrouvee"
      v-model="sasAccreditation.faculteDePharmacie"
      :live="liveSasAccreditation(24640)"
      descending
    />
    <CatalogueLive code="cccep_ouinon" v-model="sasAccreditation.dejaAccrediteeCccep" :live="liveSasAccreditation(24641)" descending />
    <TextFieldLive
      code="cccep_numero"
      :opq-if="estOui(sasAccreditation.dejaAccrediteeCccep)"
      v-model="sasAccreditation.numeroAccreditationCccep"
      :live="liveSasAccreditation(24609)"
    />
    <FileInput
      code="cccep_preuve"
      :file="sasAccreditation.preuveCccep"
      :opq-if="estOui(sasAccreditation.dejaAccrediteeCccep)"
      :live="liveSasAccreditation(24610)"
    />
    <DatePickerLive
      code="cccep_date_accreditation"
      :opq-if="estOui(sasAccreditation.dejaAccrediteeCccep)"
      v-model="sasAccreditation.dateAccreditationCccep"
      :live="liveSasAccreditation(24611)"
      :minValue="serverDatePlusNMonths(-24)"
      :maxValue="serverDate()"
    />
    <DatePickerLive
      code="cccep_date_echeance"
      :opq-if="estOui(sasAccreditation.dejaAccrediteeCccep)"
      v-model="sasAccreditation.dateEcheanceCccep"
      :live="liveSasAccreditation(24612)"
      :minValue="serverDate()"
    />
    <CatalogueLive
      code="cccep_francais"
      :opq-if="estOui(sasAccreditation.dejaAccrediteeCccep)"
      v-model="sasAccreditation.cccepPourUneFormationEnFrancais"
      :live="liveSasAccreditation(24613)"
      descending
    />
    <CatalogueLive code="type_demande" v-model="sasAccreditation.typeDeDemande" :live="liveSasAccreditation(24602)" orderBy="code" />
    <CatalogueLive
      code="accreditation_liee"
      :items="sas.accreditations"
      v-model="sasAccreditation.accreditationLieeRenouvellementOuDeuxiemeFormat"
      :opq-if="!sasAccreditation.formationNonTrouvee && estRenouvellementOuNouveauFormat"
      :live="liveSasAccreditation(24606)"
    />
    <CaseACocherLive
      :opq-if="estRenouvellementOuNouveauFormat"
      code="formation_non_trouvee"
      v-model="sasAccreditation.formationNonTrouvee"
      :live="liveSasAccreditation(24628)"
    />
    <TextFieldLive
      code="numero_ancienne_accreditation"
      :opq-if="sasAccreditation.formationNonTrouvee && estRenouvellementOuNouveauFormat"
      v-model="sasAccreditation.numeroAncienneAccreditation"
      :live="liveSasAccreditation(24642)"
    />
    <CaseACocherLive
      :opq-if="estRenouvellementOuNouveauFormat"
      code="engagement_appreciations"
      v-model="sasAccreditation.engagementAppreciations"
      :live="liveSasAccreditation(24626)"
    />
    <CatalogueLive
      code="format_formation"
      v-model="sasAccreditation.formatDeFormation"
      :live="liveSasAccreditation(24603)"
      @eudo-updated="updatePanier"
    />
    <ophq-alert code="avertissement_midi_scientifique" v-if="estMidiScientifique"></ophq-alert>
    <FileInput
      code="programme_congres"
      :file="sasAccreditation.programmeCongres"
      :opq-if="estCongres"
      :live="liveSasAccreditation(24637)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
    />
    <CatalogueLive
      code="organisation_conjointe_ouinon"
      v-model="sasAccreditation.organisationConjointe"
      :live="liveSasAccreditation(24614)"
      descending
    />
    <TextFieldLive
      code="organisation_conjointe_nom"
      :opq-if="estOui(sasAccreditation.organisationConjointe)"
      v-model="sasAccreditation.nomDeLOrganisationConjointe"
      :live="liveSasAccreditation(24604)"
    />
    <TextFieldLive code="titre_formation" v-model="sasAccreditation.titreDeLaFormation" :live="liveSasAccreditation(24607)" :maxLength="250" />
    <CatalogueLive code="clientele_visee" v-model="sasAccreditation.clienteleVisee" :live="liveSasAccreditation(24608)" orderBy="code" />
    <CatalogueLive code="sujet_principal" v-model="sasAccreditation.sujetPrincipalDeLaFormation" :live="liveSasAccreditation(24615)" />
    <CatalogueLive
      code="partenaires_financiers_ouinon"
      v-model="sasAccreditation.partenairesFinanciers"
      :live="liveSasAccreditation(24618)"
      descending
    />
    <MemoLive
      code="partenaires_financiers_details"
      :opq-if="estOui(sasAccreditation.partenairesFinanciers)"
      v-model="sasAccreditation.partenairesFinanciersEtImplications"
      :live="liveSasAccreditation(24619)"
    />
    <CaseACocherLive
      :opqIf="estOui(sasAccreditation.partenairesFinanciers)"
      code="engagement_independance"
      v-model="sasAccreditation.engagementIndependance"
      :live="liveSasAccreditation(24620)"
    />
    <CatalogueLive
      code="traitement_accelere"
      v-model="sasAccreditation.traitementAccelere"
      :live="liveSasAccreditation(24653)"
      @eudo-updated="updatePanier"
      descending
    />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import SearchOrganisation from "@/components/Common/SearchOrganisation.vue"
import PosteCanada from "@/mixins/PosteCanada"
import infosGeneralesAccreditation from "@/components/Formulaires/DemandeAccreditation/mixins/infosGeneralesAccreditation"
import { mapActions } from "vuex"
import { Queue, Api } from "@/plugins/api"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers, PosteCanada, infosGeneralesAccreditation],
  components: { SearchOrganisation },
  data() {
    return {
      organisation: null
    }
  },
  props: {
    sas: { type: Object }
  },
  watch: {
    "sas.sasAccreditation.organisationNonTrouvee"(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.setupAddressComplete()
        })
        this.organisation = null
      }
    },
    organisation() {
      this.updatePanier()
    }
  },
  mounted() {
    this.organisation = this.sasAccreditation.organisation
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({ endpoint: "demande-accreditation", sasId: this.sas.id })
    },
    organisationSelected(organisation) {
      Queue.enqueue(() =>
        Api.post("sas-accreditations", {
          fileId: this.sasAccreditation.id,
          cle: "300",
          value: organisation.organisationId
        }).then(() => {
          this.organisation = organisation
        })
      )
    },
    clearOrganisation() {
      Queue.enqueue(() =>
        Api.post("sas-accreditations", {
          fileId: this.sasAccreditation.id,
          cle: "300",
          value: null
        }).then(() => {
          this.organisation = null
        })
      )
    }
  }
}
</script>
